
















































import moment from 'moment';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PolicyDocuments, { PolicyPacket, Metadata } from '@/services/PolicyDocuments';
import { DocumentSet, DocumentSets } from './DocumentSets';
import PolicyDocumentsTable from './PolicyDocumentsTable.vue';
import { PolicyUi } from '@/common/Policy';

@Component({
	components: {
		PolicyDocumentsTable,
	},
})
export default class MmicPolicyItem extends Vue {
	@Getter( 'policies', { namespace: 'Policy' } ) private policies: PolicyUi[];
	@Prop() private packet: PolicyPacket;
	@Prop() private effectiveFrom: any;
	@Prop() private effectiveTo: any;

	private DocumentSets = DocumentSets;
	private displayedDocumentSet: DocumentSet = DocumentSets.none;
	private orderedDocumentSets: readonly DocumentSet[] = Object.freeze([
		DocumentSets.policyForms,
		DocumentSets.endorsements,
		DocumentSets.cois,
		DocumentSets.stateFundForms,
	]);

	private created(): void {
		// Well this seems kinda hacky!
		for (const metadata of this.packet.metadatas) {
			if (
				!metadata.docName &&
				((metadata.formId && metadata.formId.includes('MANU')) ||
					metadata.formId === 'SCHED')
			) {
				metadata.docName = 'MANUSCRIPT ENDORSEMENT';
			}

			if (metadata.docType === 'COI') {
				metadata.docName = DocumentSets.cois.long.singular;
			}

			if ( metadata.docType === 'PP' ) {
				const policyNumber = metadata.policyNum;
				const getPolicy = this.policies.find( p => p.policy_number === policyNumber );
				metadata.riskName = getPolicy?.policy_holder?.full_name;
			}
		}

		if (this.effectiveFrom) {
			const fromYear = this.effectiveFrom.substring(
				this.effectiveFrom.length - 4,
				this.effectiveFrom.length,
			);
			this.packet.effectiveFrom = this.effectiveFrom.replace(fromYear, this.packet.term);
		} else {
			this.packet.effectiveFrom = this.packet.term;
		}

		if (this.effectiveTo) {
			const toYear = this.effectiveTo.substring(
				this.effectiveTo.length - 4,
				this.effectiveTo.length,
			);

			this.packet.effectiveTo = this.effectiveTo.replace(
				toYear,
				parseInt(this.packet.term, 10) + 1,
			);
		} else {
			this.packet.effectiveTo = parseInt(this.packet.term, 10) + 1;
		}
	}
}
